var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogochatbot(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Composant_137_1",
    "data-name": "Composant 137 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1470",
    "data-name": "Rectangle 1470",
    width: 28,
    height: 27,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_234",
    "data-name": "Ellipse 234",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#2699fb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4",
    "data-name": "Groupe 4",
    transform: "translate(5 6)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_278",
    "data-name": "Trac\\xE9 278",
    d: "M166.838,301a.812.812,0,0,0-.838.784v1.568a.839.839,0,0,0,1.675,0v-1.568a.812.812,0,0,0-.838-.784",
    transform: "translate(-156.731 -285.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_279",
    "data-name": "Trac\\xE9 279",
    d: "M316.838,304.136a.812.812,0,0,0,.837-.784v-1.568a.839.839,0,0,0-1.675,0v1.568a.812.812,0,0,0,.838.784",
    transform: "translate(-298.356 -285.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_280",
    "data-name": "Trac\\xE9 280",
    d: "M257.837,77.568h9.157a.786.786,0,1,0,0-1.568h-9.157a.786.786,0,1,0,0,1.568",
    transform: "translate(-242.651 -71.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_281",
    "data-name": "Trac\\xE9 281",
    d: "M28.587,9.2V3.4A3.523,3.523,0,0,0,24.958,0H14.573a3.523,3.523,0,0,0-3.629,3.4V9.461H9.827a6.352,6.352,0,0,0-6.268,4.7H3.406V9.326A2.372,2.372,0,0,0,5.081,7.109,2.439,2.439,0,0,0,2.568,4.757,2.439,2.439,0,0,0,.056,7.109,2.372,2.372,0,0,0,1.731,9.326v4.956A2.377,2.377,0,0,0,0,16.518v3.136a2.439,2.439,0,0,0,2.513,2.352H3.547a6.347,6.347,0,0,0,6.28,4.757H18.76a6.347,6.347,0,0,0,6.28-4.757h1.034a2.439,2.439,0,0,0,2.513-2.352V16.518a2.439,2.439,0,0,0-2.513-2.352H25.028A5.77,5.77,0,0,0,24.4,12.6h.558A3.523,3.523,0,0,0,28.587,9.2ZM12.619,3.4a1.9,1.9,0,0,1,1.954-1.83H24.958A1.9,1.9,0,0,1,26.912,3.4V9.2a1.9,1.9,0,0,1-1.954,1.83H15.131a.885.885,0,0,0-.375.083l-2.138,1ZM2.568,6.325a.786.786,0,1,1,0,1.568.786.786,0,1,1,0-1.568M1.675,19.654V16.518a.813.813,0,0,1,.838-.784h.893v4.7H2.513a.813.813,0,0,1-.838-.784m25.237-3.136v3.136a.813.813,0,0,1-.838.784h-.893v-4.7h.893a.813.813,0,0,1,.838.784m-3.406-1.045v5.279a4.607,4.607,0,0,1-4.746,4.443H9.827a4.607,4.607,0,0,1-4.746-4.443V15.472a4.607,4.607,0,0,1,4.746-4.443h1.117v2.352a.837.837,0,0,0,1.212.7L15.329,12.6h7.049a4.272,4.272,0,0,1,1.129,2.875",
    transform: "translate(0 0.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_282",
    "data-name": "Trac\\xE9 282",
    d: "M257.837,137.568h9.157a.786.786,0,1,0,0-1.568h-9.157a.786.786,0,1,0,0,1.568",
    transform: "translate(-242.651 -128.654)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_283",
    "data-name": "Trac\\xE9 283",
    d: "M211,391.784a.812.812,0,0,0,.838.784h3.35a.786.786,0,1,0,0-1.568h-3.35a.812.812,0,0,0-.838.784",
    transform: "translate(-199.219 -370.325)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogochatbot);
export default __webpack_public_path__ + "static/media/Logochatbot.86df426e17b3c4b37097c49e7b74329e.svg";
export { ForwardRef as ReactComponent };